export const CreditCard = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className="w-full">
		<path
			d="M4.05558 9.99995C4.05558 9.66244 4.32919 9.38883 4.66669 9.38883H4.67336C5.01087 9.38883 5.28447 9.66244 5.28447 9.99995C5.28447 10.3375 5.01087 10.6111 4.67336 10.6111H4.66669C4.32919 10.6111 4.05558 10.3375 4.05558 9.99995Z"
			fill="currentColor"
		/>
		<path
			d="M7.33336 9.38883C6.99585 9.38883 6.72225 9.66244 6.72225 9.99995C6.72225 10.3375 6.99585 10.6111 7.33336 10.6111H8.66669C9.0042 10.6111 9.2778 10.3375 9.2778 9.99995C9.2778 9.66244 9.0042 9.38883 8.66669 9.38883H7.33336Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.38892 5.33328C1.38892 3.8912 2.55795 2.72217 4.00003 2.72217H12C13.4421 2.72217 14.6111 3.8912 14.6111 5.33328V10.6666C14.6111 12.1087 13.4421 13.2777 12 13.2777H4.00003C2.55795 13.2777 1.38892 12.1087 1.38892 10.6666V5.33328ZM2.61114 5.33328C2.61114 4.56622 3.23296 3.94439 4.00003 3.94439H12C12.7671 3.94439 13.3889 4.56622 13.3889 5.33328V6.0555H2.61114V5.33328ZM13.3889 7.27772V10.6666C13.3889 11.4337 12.7671 12.0555 12 12.0555H4.00003C3.23296 12.0555 2.61114 11.4337 2.61114 10.6666V7.27772H13.3889Z"
			fill="currentColor"
		/>
	</svg>
);
